import React from 'react';
import PropTypes from 'prop-types';

import SearchFeedbackSubmitted from 'components/search/SearchFeedbackSubmitted';

import css from 'styles/components/search/searchFeedback.scss';

const SearchFeedback = ({ handleClick, feedbackSubmitted = false }) => (
    <>
      {
        feedbackSubmitted ?
          <SearchFeedbackSubmitted /> :
          <div className={css.searchFeedback}>
            <p id="feedback">
              Do these items match what you were searching for?
            </p>
            <button type="submit" aria-describedby="feedback" onClick={() => handleClick(true)}>Yes</button>
            <button type="submit" aria-describedby="feedback" onClick={() => handleClick(false)}>No</button>
          </div>

      }
    </>
);

SearchFeedback.propTypes = {
  handleClick: PropTypes.func.isRequired
};

export default SearchFeedback;
